import createCustomEvent from '../../utils/create-custom-event';
import dispatchCustomEvent from '../../utils/dispatch-custom-event';
import { UPDATE_USER_LOCATION_DATA } from '../../state/redux/features/location/types';

export default function updateUserLocation({ postalCode, locationId }) {
  const payload = {
    ...(postalCode && { postalCode }),
    locationId,
  };

  dispatchCustomEvent(
    createCustomEvent(this.get().events?.locationUpdated, {
      bubbles: false,
      detail: payload,
    }),
  );
  return this.internalStore.dispatch({
    type: UPDATE_USER_LOCATION_DATA,
    payload,
  });
}
